module.exports = __webpack_public_path__ + "static/media/trz1000-compressor.4587d9b7.jpg";